import OtpInput from './OtpInput.vue';

export default OtpInput;
